/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import {
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import Switch from "@mui/material/Switch";
import MoonLoader from "react-spinners/MoonLoader";
import Pagination from "../../../../Helper/Pagination";

export default function MailList() {
  const [FooterNamelList, setFooterNamelList] = useState();
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [submitLoader, setsubmitLoader] = useState(false);

  const [selectedData, setSelectedData] = useState("");

  useEffect(() => {
    getFooterNamelList();
  }, [search_key, currentPage]);

  const getFooterNamelList = () => {
    setLoading(true);

    const param = {
      limit: 10,
      page: currentPage,
      sorting: "sortingKey|desc",
      search_key: search_key,
    };

    PostService(API_URL.GET_MAIL_LIST, param).then((res) => {
      if (res?.data?.status === true) {
        setFooterNamelList(res.data.data.rows);
        SetTotalPageCount(res.data.totalPages);
        SetTotalCount(res.data.totalItems);
        setCount(res.data.currentPage * param.limit);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };

  const [error, setError] = useState(false);

  const [subject, setsubject] = useState("");
  const [section, setsection] = useState("");
  const [b_content, setb_content] = useState("");
  const [f_content, setf_content] = useState("");
  const [h_content, seth_content] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    setsubject(selectedData?.subject);
    setsection(selectedData?.section);
    setb_content(selectedData?.b_content);
    setf_content(selectedData?.f_content);
    seth_content(selectedData?.h_content);
    setStatus(selectedData?.status);
  }, [selectedData]);

  const submit = (e) => {
    e.preventDefault();

    if (!subject || !section || !b_content || !f_content || !h_content) {
      setError(true);
      return;
    }

    setsubmitLoader(true);

    let formdata = {
      id: selectedData?.id,
      subject,
      section,
      b_content,
      h_content,
      f_content,
    };

    PostService(API_URL.UPDATE_MAIL, formdata).then(
      (res) => {
        console.log(res);
        if (res.data.status === true) {
          showSuccessAlert(res?.data?.message, getFooterNamelList);
          resetFunc();
          document.getElementById("closeEditModal").click();
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  const changeStatus = async (id, status) => {
    const data = {
      id: id,
      status: status === "active" ? "inactive" : "active",
    };

    PostService(API_URL.CHANGE_MAIL_STATUS, data).then(
      (res) => {
        if (res.data.status) {
          showSuccessAlert(res?.data?.message, getFooterNamelList);
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  function resetFunc() {
    setStatus();
    setError(false);
    setsubmitLoader(false);
  }

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3 className="default_color">Mail Content List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Mail Content List</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-md-4 offset-md-8 p-0">
                      <nav className="navbar">
                        <input
                          className="form-control"
                          type="text"
                          name="firstnamesearch"
                          placeholder="Search by Keyword"
                          autoComplete="off"
                          onChange={(e) => {
                            setTimeout(() => {
                              setsearch_key(e.target.value);
                              setCurrentPage(0);
                            }, 400);
                          }}
                        />
                      </nav>
                    </div>
                  </div>

                  <div className="table-responsive">
                    {!loading && (
                      <table className="table table-hover text-nowrap table-striped table-bordered">
                        <thead>
                          <tr>
                            <th className="text-center">S.No</th>
                            <th className="text-center">Section</th>
                            <th className="text-center">Subject</th>
                            <th className="text-center">Status</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {FooterNamelList?.map((data, i) => (
                            <tr key={i} className="text-center">
                              <td className="text-center">
                                {i + S_No_Count + 1}
                              </td>
                              <td className="text-center">
                                {data?.section ? data?.section : "N/A"}
                              </td>
                              <td className="text-center">
                                {data?.subject ? data?.subject : "N/A"}
                              </td>
                              <td className="text-center">
                                <span
                                  className={
                                    data?.status === "active" ||
                                    data?.status === "Active"
                                      ? "badge badge-success"
                                      : "badge badge-danger"
                                  }
                                >
                                  {data?.status}
                                </span>
                              </td>
                              <td className="text-center">
                                <span className="toggle-switch">
                                  <Switch
                                    checked={
                                      data?.status === "active" ||
                                      data?.status === "Active"
                                    }
                                    onChange={() => {
                                      changeStatus(data?.id, data?.status);
                                    }}
                                    size="small"
                                    color="primary"
                                    inputProps={{
                                      "aria-label": "toggle switch",
                                    }}
                                  />
                                </span>
                                <span
                                  title="Update"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  data-toggle="modal"
                                  data-target="#EditModal"
                                  onClick={() => {
                                    setSelectedData(data);
                                  }}
                                >
                                  <i className="text-dark fas fa-pen"></i>{" "}
                                </span>
                              </td>
                            </tr>
                          ))}
                          {FooterNamelList && FooterNamelList.length === 0 && (
                            <tr>
                              <td colSpan="5" className="text-center">
                                <h6 className="p-3"> No Data Found </h6>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                    {loading ? (
                      <div className="LoaderSpinner">
                          <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
                        <div>Loading... Please wait.</div>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="mt-4">
                      <Pagination
                        counting={S_No_Count}
                        totaldata={TotalCount}
                        pagecount={TotalPageCount}
                        onChangePage={handlePageClick}
                        activePage={currentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div
        className="modal fade"
        id="EditModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLabel">
                Edit Mail
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFunc}
              >
                {" "}
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={(e) => submit(e)}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <label>Section</label>
                      <input
                        type="text"
                        name="section"
                        className="form-control"
                        value={section}
                        onChange={(e) => setsection(e?.target?.value)}
                        placeholder="Section"
                      />
                      {error && !section && (
                        <div className="error mt-1">Section is required</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <label>Subject</label>
                      <input
                        type="text"
                        name="Subject"
                        className="form-control"
                        value={subject}
                        onChange={(e) => setsubject(e?.target?.value)}
                        placeholder="Subject"
                      />
                      {error && !subject && (
                        <div className="error mt-1">Subject is required</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <label>Header Content</label>
                      <textarea
                        type="text"
                        name="name"
                        className="form-control"
                        value={h_content}
                        onChange={(e) => seth_content(e?.target?.value)}
                        placeholder="Header Content"
                      >
                        </textarea>
                      {error && !h_content && (
                        <div className="error mt-1">Header Content is required</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <label>Body Content</label>
                      <textarea
                        type="text"
                        name="name"
                        className="form-control"
                        value={b_content}
                        onChange={(e) => setb_content(e?.target?.value)}
                        placeholder="Body Content"
                      ></textarea>
                      {error && !b_content && (
                        <div className="error mt-1">Body Content is required</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <label>Footer Content</label>
                      <textarea
                        type="text"
                        name="name"
                        className="form-control"
                        value={f_content}
                        onChange={(e) => setf_content(e?.target?.value)}
                        placeholder="Footer Content"
                      ></textarea>
                      {error && !f_content && (
                        <div className="error mt-1">Footer Content is required</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  id="closeEditModal"
                  data-dismiss="modal"
                  onClick={resetFunc}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={submitLoader}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
